module.exports = {"domain":"api-bank.auth0.com","audience":"api.api-university.com","clientId":"zSykOLKS95wO01inWzOLdZ6xpTOWPrLM"}


//////////////////
// WEBPACK FOOTER
// ./src/auth_config.json
// module id = 438
// module chunks = 0